import { useState } from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';

// Images
import IconSuccess from 'Assets/images/icons/success.png';
import IconCopy from 'Assets/images/icons/copy.png';

export default (props) => {
  const [tooltipText, setTooltipText] = useState('Copy to clipboard');

  const handleCopyText = () => {
    navigator.clipboard.writeText(window.location.href);
    setTooltipText('Copied');
  };

  return (
    <Modal {...props} size="md" centered className="waiting-list-modal">
      <Modal.Header closeButton>
        <Modal.Title>Congratulations!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={IconSuccess} alt="success" className="icon-success" />
        <p className="color-white mb-4">You’re on the waitlist! </p>

        <p className="description">
          Share your unique referral link with friends to earn points and move up the waitlist. Plus, you’ll be eligible to win $500 in prizes!
        </p>

        <div className="copy-box">
          <OverlayTrigger key="top" placement="top" overlay={<Tooltip id="tooltip-top">{tooltipText}</Tooltip>}>
            <img src={IconCopy} alt="copy" onClick={handleCopyText} />
          </OverlayTrigger>
          <span>{window.location.href}</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};
